export class S3Config {
    bucket: string = "bidjonesbucketprivate";
    accessKey: string = "AKIAJJNDTANX7JZ5NFPA";
    secretAccessKey: string = "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";
    region: string = "us-east-2";
    folder: string = "";
}


// WEBPACK FOOTER //
// ./src/app/_services/s3.config.ts